export const REALTIME_V2_DEFAULT_URL = "wss://realtime.sealevel.dev/v2";
